import React, { Component } from "react"
import Helmet from "react-helmet"
import Link from "gatsby-link"
import styled from "styled-components"
import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"
import Steps from "../components/Steps"
import "../css/index.css"
import "../css/typography.css"
import "../css/Hide.css"
import CarouselContainer from "../components/Carousel"
import SectionContainer from "../components/SectionContainer"
import SectionContainerBackground from "../components/SectionContainerBackground"
import { SectionCharityBackground } from "../components/SectionCharityBackground"
import SectionContent from "../components/SectionContent"
import SectionImages from "../components/SectionImages"
import SectionImage from "../components/SectionImage"
import TinyPrice from "../components/TinyPrice"
import TinySignUp from "../components/TinySignUp"
import withScreensize from "../components/withScreensize"
import ScreensizeProvider from "../components/ScreensizeProvider"
import {
  TinyButton,
  TinyButtonAlt,
  TinyButtonWhite
} from "../components/Button.js"
import {
  SECONDARY_TEXT,
  ACTIVE_TEXT,
  TINY_SHADOW
} from "../components/consts/colors"

import productCard from "../assets/product-card.png"
import homeWidget from "../assets/home-widget.png"
import homeStore from "../assets/home-store.png"
import homeBG from "../assets/home-bg.svg"
import dashBG from "../assets/dash-bg.svg"
import charityBG from "../assets/charity-bg.svg"
import designerView from "../assets/designer-view.png"
import designerDetail from "../assets/designer-detail.png"
import productWidget from "../assets/product-widget.png"
import embedDash from "../assets/embed-dash.png"
import dashboard from "../assets/dashboard.png"
import price from "../assets/price.png"
import charity01 from "../assets/charity-01.png"

const pageData = {
  sectionOneHeadline: "Sell custom merch without all the work.",
  sectionOneCopy:
    "Add TinyMerch to your existing website in just a few minutes. We handle everything: orders, inventory, shipping, and payment. You sell your products and get paid!",
  sectionOnePlaceholder: "Name Your Store",

  SectionCharityHeadline: "Giving back made simpler",
  SectionCharityCopy:
    "TinyMerch is the perfect tool for fundraising or donating to charities. From your Seller's Dashboard you can choose to donate your store's proceeds directly to a charity with a single click.",
  SectionCharityLink: "https://my.tinymerch.com",
  SectionCharityCTA: "Learn More About Donations",
  SectionCharityAddmendment:
    "Are you a charity interested in being added to our list?",
  SectionCharityMailToLink: "mailto:team@tinymerch.com",
  SectionCharityMailToText: "Let us Know!",

  SectionPricingHeadline: "Pricing Plan",
  SectionPricingCopy:
    "Yep, TinyMerch is free. In fact, it's sort of a subscription that pays you! No monthly fees. You sell merch. We send you the profits.",
  SectionPricingLink: "https://my.tinymerch.com",
  SectionPricingCTA: "Get Started!",

  SectionConclusionHeadline: "Let's Sell Together.",
  SectionConclusionCopy: "Get started selling merch on your site in 5 minutes.",
  SectionConclusionLink: "https://my.tinymerch.com",
  SectionConclusionCTA: "Checkout a Store",
  SectionConclusionLink2: "https://my.tinymerch.com",
  SectionConclusionCTA2: "Get Started!"
}

const Home = withScreensize(props => {
  const isMobile = props.screensize === "phones"
  const isTablet = props.screensize === "thatUglyInBetweenSize"
  const isSmall = props.screensize === "devWithConsoleOpen"
  const isWidescreen = props.screensize === "widescreenFools"

  return (
    <div>
      <Helmet title="TinyMerch" />
      <SectionContainer justify="center" align="center">
        <SectionContent
          justify="center"
          color
          width={
            isMobile ? "90%" : isTablet ? "80%" : isWidescreen ? "40%" : "50%"
          }
          height={
            isMobile
              ? "200px"
              : isTablet ? "250px" : isWidescreen ? "400px" : "400px"
          }>
          <h1>{pageData.sectionOneHeadline}</h1>
          {/* <h3 style={{ fontWeight: "400" }}>
            Your custom merch with no overhead, for free.
          </h3> */}
          <p className="title_copy">{pageData.sectionOneCopy}</p>
          {/* <TinySignUp /> */}
          <a href="https://my.tinymerch.com">
            <TinyButton>Get Started</TinyButton>
          </a>
          <strong>Simple Setup • No inventory • Completely free</strong>
        </SectionContent>
        <SectionImages
          width={isMobile ? "100%" : isTablet ? "100%" : "50%"}
          height={
            isMobile
              ? "250px"
              : isTablet ? "450px" : isWidescreen ? "600px" : "600px"
          }>
          <SectionImage
            shadow
            src={homeStore}
            ImgWidth={
              isMobile
                ? "350px"
                : isTablet ? "500px" : isWidescreen ? "700px" : "550px"
            }
            positionTB={
              isMobile
                ? "0px"
                : isTablet ? "0px" : isWidescreen ? "90px" : "100px"
            }
            positionLR={
              isMobile ? "13%" : isTablet ? "20%" : isWidescreen ? "0%" : "0%"
            }
          />
          <SectionImage
            shadow
            src={productWidget}
            ImgWidth={
              isMobile
                ? "100px"
                : isTablet ? "200px" : isWidescreen ? "250px" : "225px"
            }
            positionTB={
              isMobile
                ? "10px"
                : isTablet ? "-20px" : isWidescreen ? "60px" : "70px"
            }
            positionLR={
              isMobile
                ? "-30%"
                : isTablet ? "-50%" : isWidescreen ? "-120%" : "-140%"
            }
          />
        </SectionImages>
      </SectionContainer>
      {/* <SectionContainer
        height={
          isMobile ? (
            "250px"
          ) : isTablet ? (
            "500px"
          ) : isWidescreen ? (
            "750px"
          ) : (
            "700px"
          )
        }>
        <CarouselContainer />
      </SectionContainer> */}
      <SectionContainer
        align="center"
        justify="center"
        height={
          isMobile
            ? "250px"
            : isTablet ? "500px" : isWidescreen ? "750px" : "700px"
        }>
        <Steps />
      </SectionContainer>
      <SectionContainer
        align="center"
        justify="center"
        height={
          isMobile
            ? "650px"
            : isTablet ? "750px" : isWidescreen ? "600px" : "600px"
        }>
        <SectionCharityBackground />
        <SectionContent
          justify={isMobile ? "center" : isTablet ? "flex-start" : "center"}
          white
          width={
            isMobile ? "90%" : isTablet ? "80%" : isWidescreen ? "40%" : "50%"
          }
          height="350px">
          <Fade bottom delay={0} duration={200}>
            <h1>{pageData.SectionCharityHeadline}</h1>
          </Fade>
          <Fade bottom delay={50} duration={200}>
            <p>{pageData.SectionCharityCopy}</p>
          </Fade>
          <Fade bottom delay={100} duration={200}>
            <Link to="/blog/donations">
              <TinyButtonWhite>{pageData.SectionCharityCTA}</TinyButtonWhite>
            </Link>
          </Fade>
          <Fade bottom delay={150} duration={200}>
            <p>
              {pageData.SectionCharityAddmendment}
              <a
                style={{ color: "white", fontWeight: "700" }}
                href={pageData.SectionCharityMailToLink}>
                &nbsp;
                {pageData.SectionCharityMailToText}
              </a>
            </p>
          </Fade>
        </SectionContent>
        <SectionImages
          width={
            isMobile ? "100%" : isTablet ? "100%" : isWidescreen ? "60%" : "50%"
          }
          height={
            isMobile
              ? "250px"
              : isTablet ? "300px" : isWidescreen ? "400px" : "400px"
          }>
          <Fade right big delay={200} duration={300}>
            <SectionImage
              shadow
              src={charity01}
              ImgWidth={
                isMobile
                  ? "320px"
                  : isTablet ? "400px" : isWidescreen ? "650px" : "600px"
              }
              positionTB={
                isMobile
                  ? "50px"
                  : isTablet ? "0px" : isWidescreen ? "0px" : "0px"
              }
              positionLR={
                isMobile ? "0%" : isTablet ? "0%" : isWidescreen ? "20%" : "0%"
              }
            />
          </Fade>
        </SectionImages>
      </SectionContainer>
      <SectionContainer
        height={
          isMobile
            ? "500px"
            : isTablet ? "600px" : isWidescreen ? "600px" : "600px"
        }>
        <SectionContainerBackground
          BG={homeBG}
          zindex="-3"
          height={
            isMobile
              ? "600px"
              : isTablet ? "600px" : isWidescreen ? "950px" : "800px"
          }
          positionTB={
            isMobile
              ? "-50px"
              : isTablet ? "-150px" : isWidescreen ? "-150px" : "-100px"
          }
        />
        <SectionContent
          justify="center"
          positionTB={
            isMobile
              ? "-25px"
              : isTablet ? "-100px" : isWidescreen ? "0px" : "0px"
          }
          color
          height={isMobile ? "400px" : isTablet ? "450px" : "550px"}
          width={
            isMobile ? "90%" : isTablet ? "80%" : isWidescreen ? "40%" : "50%"
          }
          align="center">
          <Fade bottom delay={0} duration={200}>
            <h1>{pageData.SectionPricingHeadline}</h1>
          </Fade>
          <Fade bottom delay={50} duration={200}>
            <TinyPrice />
          </Fade>
          <Fade bottom delay={100} duration={200}>
            <p style={{ textAlign: "center" }}>{pageData.SectionPricingCopy}</p>
          </Fade>
          <Fade bottom delay={150} duration={200}>
            <a href={pageData.SectionPricingLink}>
              <TinyButton>{pageData.SectionPricingCTA}</TinyButton>
            </a>
          </Fade>
        </SectionContent>
        <SectionImages
          absolute
          width="0%"
          height={
            isMobile
              ? "0px"
              : isTablet ? "0px" : isWidescreen ? "600px" : "500px"
          }>
          <Fade right big delay={200} duration={300}>
            <SectionImage
              src={price}
              ImgWidth={
                isMobile
                  ? "500px"
                  : isTablet ? "550px" : isWidescreen ? "800px" : "700px"
              }
              positionTB={
                isMobile
                  ? "0%"
                  : isTablet ? "-120px" : isWidescreen ? "30px" : "10px"
              }
              positionLR={
                isMobile
                  ? "20%"
                  : isTablet ? "40%" : isWidescreen ? "-80%" : "-70%"
              }
            />
          </Fade>
        </SectionImages>
      </SectionContainer>
      <SectionContainer
        height={
          isMobile
            ? "350px"
            : isTablet ? "400px" : isWidescreen ? "500px" : "500px"
        }>
        <SectionContent
          justify="center"
          color
          width={
            isMobile ? "90%" : isTablet ? "80%" : isWidescreen ? "40%" : "50%"
          }
          height={
            isMobile
              ? "350px"
              : isTablet ? "400px" : isWidescreen ? "550px" : "500px"
          }
          align="center">
          <Fade bottom delay={0} duration={200}>
            <h1>{pageData.SectionConclusionHeadline}</h1>
          </Fade>
          <Fade bottom delay={50} duration={200}>
            <p style={{ textAlign: "center" }}>
              {pageData.SectionConclusionCopy}
            </p>
          </Fade>
          <Fade bottom delay={100} duration={200}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "600px"
              }}>
              {/* <a
              style={{ padding: "0px 10px" }}
              href={pageData.SectionConclusionLink}>
              <TinyButtonAlt>{pageData.SectionConclusionCTA}</TinyButtonAlt>
            </a> */}
              <a
                style={{ padding: "0px 10px" }}
                href={pageData.SectionConclusionLink2}>
                <TinyButton>{pageData.SectionConclusionCTA2}</TinyButton>
              </a>
            </div>
          </Fade>
          <Fade bottom delay={125} duration={200}>
            <strong>Simple Setup • No inventory • Completely free</strong>
          </Fade>
        </SectionContent>
      </SectionContainer>
    </div>
  )
})

export default props => (
  <ScreensizeProvider>
    <Home {...props} />
  </ScreensizeProvider>
)



// WEBPACK FOOTER //
// ./src/pages/index.js